import React, { MouseEventHandler } from 'react';
import { useNavigate } from 'react-router-dom';
import CheckboxControl from '../../../components/Fields/CheckboxControl';
import { useAuth } from "../../../contexts/authContext";
import ItemSearchResult from '../../../models/ItemSearchResult';
import FormatUtils from '../../../utils/FormatUtils.js';
import ItemColorControl from '../../Items/Components/ItemColorControl';

export interface ItemRevisionCardProps {
    itemRevision: ItemSearchResult
    index: number
    handleItemClicked: (itemRevision: ItemSearchResult) => void
    handleItemSelected?: (index: number) => void
}

const ItemRevisionCard: React.FC<ItemRevisionCardProps> = ({ itemRevision, index, handleItemClicked, handleItemSelected }) => {
    const { user } = useAuth();
    const navigate = useNavigate();

    let createdDate: string;
    let modifiedDate: string = '';

    const formatUtils = new FormatUtils();
    createdDate = formatUtils.formatDate(itemRevision.createdOn);
    if (itemRevision.modifiedOn) {
        modifiedDate = formatUtils.formatDate(itemRevision.modifiedOn);
    }

    let brands = itemRevision.brands;
    let categories = itemRevision.categories;

    let designers = '';
    let coordinators = '';
    if (itemRevision.itemEmployees) {
        designers = itemRevision.itemEmployees.filter(x => x.functionalRoleId == 1).map(x => x.employee.name).join(', ');
        coordinators = itemRevision.itemEmployees.filter(x => x.functionalRoleId == 2).map(x => x.employee.name).join(', ');
    }

    var status = itemRevision.itemStatusName;
    var backgroundColor = 'darkgray';
    if (itemRevision.itemStatusColor)
        backgroundColor = itemRevision.itemStatusColor;

    var activeColor = 'red'
    var borderWidth = 3
    if (itemRevision.isActive === true) {
        activeColor = 'black'
        borderWidth = 1
    }

    function SetSelectedItem() {
        if (handleItemSelected) {
            handleItemSelected(index);
            console.log('select:' + index);
        }
        else {
            ItemClicked()
        }
    }

    function ItemClicked() {
        if (handleItemClicked)
            handleItemClicked(itemRevision);
    }

    function onCopyItemNrClick(event: React.MouseEvent<HTMLElement>) {
        navigator.clipboard.writeText(itemRevision.itemNr);
        event.stopPropagation();
    }

    var colorControls = itemRevision.colors?.map((itemColor, idx) => {
        return <ItemColorControl itemColor={itemColor} onClick={() => { }} />
    })


    return (
        <div style={{ width: 276, height: 463, overflow: 'hidden', border: borderWidth + 'px solid ' + activeColor, margin: 15, borderRadius: 5 }}>
            <div style={{ position: 'relative' }}>
                <div style={{ backgroundColor: backgroundColor, color: 'white', padding: 5, overflow: 'hidden', minHeight: 137 }} onClick={() => SetSelectedItem()}>
                    <span><i className={'fa fa-clipboard'} onClick={onCopyItemNrClick} /></span>&nbsp;
                    <span style={{ fontSize: 23 }}>{itemRevision.itemNr}</span><span style={{ fontSize: 23 }}>{' - v' + itemRevision.revisionNumber}</span>
                    {handleItemSelected != undefined &&
                        <span className="pull-right">
                            <CheckboxControl name='test' value={itemRevision.selected} onChange={() => { }} width={20} validationResults={[]} />
                        </span>
                    }
                    <div className='cardItemName' style={{ margin: 0, maxHeight: 18, overflow: 'hidden', fontSize: 13 }}>{itemRevision.name}</div>
                    <div style={{ margin: 0, maxHeight: 25, minHeight: 20, overflow: 'auto', fontSize: 13, fontWeight: 700 }}><b>{status}</b></div>
                    <div style={{ backgroundColor: 'black', display: 'flex', flexDirection: 'row', height: 55 }}>
                        <div style={{ marginTop: 10, marginLeft: 5, maxHeight: 25, overflow: 'auto', fontSize: 13, width: 85 }}>{createdDate}</div>
                        <div style={{ marginTop: 10, maxHeight: 25, overflow: 'auto', fontSize: 13, width: 106 }}></div>
                        <div style={{ marginTop: 10, marginRight: 5, maxHeight: 35, overflow: 'auto', fontSize: 13, width: 85, textAlign: 'right' }}>{modifiedDate}</div>
                    </div>
                </div>
                <div className="content" style={{ padding: 0 }} onClick={() => ItemClicked()}>
                    <div style={{ width: 273, height: 207, overflow: 'hidden', backgroundColor: 'white', textAlign: 'center' }}>
                        <img className='cardImage' src={itemRevision.imageUrl} alt="..." />
                    </div>
                    <div style={{ backgroundColor: '#E2E2E2', color: 'black', textAlign: 'left', padding: 5 }}>
                        {itemRevision.divisionName && <div style={{ maxHeight: 17, overflow: 'hidden', fontSize: 13 }}><b>{"Division: "}</b>{itemRevision.divisionName}</div>}
                        <div style={{ maxHeight: 17, overflow: 'hidden', fontSize: 13 }}><b>{"Brand: "}</b>{brands} <br /></div>
                        <div style={{ maxHeight: 17, overflow: 'hidden', fontSize: 13 }}> <b>{"Category: "}</b>{categories}</div>
                    </div>
                    {itemRevision?.colors.length == 0 &&
                        <div style={{ backgroundColor: '#F0F0F0', color: 'black', textAlign: 'left', padding: 5 }}>
                            <div style={{ maxHeight: 17, overflow: 'hidden', fontSize: 13 }}><b>{"Designer: "}</b>{designers}</div>
                            <div style={{ maxHeight: 17, overflow: 'hidden', fontSize: 13 }}><b>{"License admin: "}</b>{coordinators}</div>
                        </div>
                    }
                    {itemRevision.colors &&
                        <div style={{ backgroundColor: '#F0F0F0', color: 'black', textAlign: 'left', padding: 5 }}>
                            {colorControls}
                        </div>
                    }
                </div>
            </div>
            {itemRevision.isActive == false && <div style={{ color: 'white', backgroundColor: activeColor, textAlign: 'center' }}>Inactive</div>}
        </div>
    );
}

export default ItemRevisionCard;